import React from 'react';
import { DatoCmsLink, DatoCmsStatisticListItem } from '../../../schema/datocms/blocks';
import { getBrandClassFromHex } from '../../../utilities/brand-color';
import Link from '../../link/link';

const StatisticListItemComponent = ({ item, sourceIndex }: { item: DatoCmsStatisticListItem, sourceIndex?: number}): React.ReactElement => {
    const link: DatoCmsLink | undefined = item?.links && item.links.length > 0 ? item.links[0] : undefined;
    const statisticColorClass: string = item?.colorOverride && item.colorOverride.hex ? getBrandClassFromHex(item.colorOverride.hex) : 'theme-primary-text';
    const statisticTextClass: string = `text-${statisticColorClass}`;
    const sourceClass: string = link ? '' : 'text-theme-secondary-text';

    let source = (item.source && <div className={`text-sm ${sourceClass}`}>{sourceIndex && sourceIndex > 0 && <sup>[{sourceIndex}]</sup>} Source: {item.source}</div>);
    if (source && link) {
        source = (
            <Link
                internalPageReference={link.internalPageReference}
                internalPageSectionId={link.internalSectionComponentId}
                externalPageUrl={link.externalPageUrl}
            >{source}</Link>
        );
    }

    return (
        <div className="flex flex-col items-center space-y-8">
            <div className={`font-serif text-6xl font-semibold ${statisticTextClass}`}>{item.statistic}</div>

            <div className="text-center text-theme-secondary-text">{item.description}{sourceIndex && sourceIndex > 0 && <sup>[{sourceIndex}]</sup>}</div>

            { source }
        </div>
    );
};

export default StatisticListItemComponent;
